<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="List" name="first">
        <div v-for="(month, year) of api.data.orders" :key="year">
          <h1>{{ year }}</h1>

          <div v-for="(monthData, monthName) of month" :key="monthName">
            <h2>{{ monthName }}</h2>
            <el-table :data="monthData.orders" style="width: 100%">
              <el-table-column prop="id" label="#" width="80" />
              <el-table-column prop="products" label="Items" width="280">
                <template slot-scope="scope">
                  <p v-html="scope.row.products" />
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Status" width="85">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status.class"
                    disable-transitions
                  >{{scope.row.status.name}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="created" label="Completed" width="145" />
              <el-table-column prop="total" label="Total" width="80" />
              <el-table-column prop="piggybank" label="Piggybank" width="100" />
            </el-table>

            <el-row :gutter="20" class="monthStat">
              <el-col :span="12">
                <el-tag>Total: {{ monthData.info.fail + monthData.info.success }} orders</el-tag>
                <el-tag type="success">{{ monthData.info.success }} successful</el-tag>
                <el-tag type="danger">{{ monthData.info.fail }} canceled</el-tag>
              </el-col>
              <el-col :span="12">
                <h3>{{ monthData.info.piggybank }} AED</h3>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Calendar" name="second" >
        <el-calendar v-model="value">
          <template slot="dateCell" slot-scope="{data}">
            <span>{{ data.day.split('-').slice(2).join('') }}</span>
            <p v-html="getCell(data)" />
          </template>
        </el-calendar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import order from "../api/order";

export default {
  data() {
    return {
      api: {},
      activeName: "first",
      value: new Date(),
      lastYear: 0,
      lastMonth: 0
    }
  },
  mounted () {
    // eslint-disable-next-line no-return-assign
    order.getPiggybank(localStorage.token, response => (this.api = response));
  },
  methods: {
    getCell (date) {
      let index = date.day.split("-").join("")

      if (this.api.calendar[index] !== undefined) {
        let data = this.api.calendar[index];
        return `<div class="el-tag el-tag--${data.className} el-tag--light">${data.title}</div>`;
      }
      return ''
    }
  }
};
</script>

<style scoped>
.monthStat {
  padding: 10px;
}
.monthStat h3 {
  text-align: right;
  margin: 0;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
